let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lBjbF")).then(() => parcelRequire('5nmGk'));